import React from 'react';
import PropTypes from 'prop-types';
import { Descriptions } from 'antd';
import { COLORS } from '@theme/styles';
import { Tag } from '@components/common';
import moment from 'moment';

function renderUserRole(role) {
  switch (role) {
    case 'house_keeper':
      return <Tag content="House Keeper" color={COLORS.cyan} />;

    case 'super_admin':
      return <Tag content="Super Admin" color={COLORS.dark_green} />;

    case 'admin':
      return <Tag content="Admin" color={COLORS.dark_blue} />;

    case 'property_manager':
      return <Tag content="Property Manager" color={COLORS.dark_yellow} />;
  }
}

function BasicUserInfo(props) {
  const {
    regions,
    data: {
      firstName,
      lastName,
      email,
      phone,
      role,
      regionID,
      status,
      activeAt,
      deactivatedAt
    }
  } = props;
  const region = regionID
    ? regions.find(item => item.regionID === regionID)
    : null;

  const { name: regionName = '' } = region || {};

  return (
    <Descriptions bordered column={3} style={{ width: '100%' }}>
      <Descriptions.Item label="Name">
        {firstName} {lastName}
      </Descriptions.Item>
      <Descriptions.Item label="Email">{email}</Descriptions.Item>
      <Descriptions.Item label="Phone">{phone}</Descriptions.Item>
      <Descriptions.Item label="Role">{renderUserRole(role)}</Descriptions.Item>
      <Descriptions.Item label="Region">{regionName}</Descriptions.Item>
      <Descriptions.Item label="Status">{status}</Descriptions.Item>
      {role == 'house_keeper' && (
        <Descriptions.Item label="Active At">{activeAt}</Descriptions.Item>
      )}
      {status == 'deactivated' && deactivatedAt && (
        <Descriptions.Item label="Deactivated At">
          {moment(deactivatedAt).format('YYYY-MM-DD')}
        </Descriptions.Item>
      )}
    </Descriptions>
  );
}

BasicUserInfo.propTypes = {
  data: PropTypes.object,
  regions: PropTypes.array
};

export default BasicUserInfo;
